import { useCallback, useMemo } from "react";
import { allProducts } from "@/mocks/products";

const STORAGE_KEY = "generalstore_recently_viewed";
const MAX_ITEMS = 8;

function readIds(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeIds(ids: string[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // localStorage full or unavailable — silently ignore
  }
}

export function useRecentlyViewed(currentProductId?: string) {
  const addToRecentlyViewed = useCallback((productId: string) => {
    const ids = readIds();
    const filtered = ids.filter((id) => id !== productId);
    filtered.unshift(productId);
    writeIds(filtered.slice(0, MAX_ITEMS));
  }, []);

  const recentlyViewedProducts = useMemo(() => {
    const ids = readIds();
    const lookups = ids.reduce<Record<string, number>>((acc, id, idx) => {
      if (!acc[id]) acc[id] = idx;
      return acc;
    }, {});

    return allProducts
      .filter((p) => lookups[p.id] !== undefined && p.id !== currentProductId)
      .sort((a, b) => lookups[a.id] - lookups[b.id])
      .slice(0, 6);
  }, [currentProductId]);

  return { recentlyViewedProducts, addToRecentlyViewed };
}